module.exports = __webpack_public_path__ + "static/home-intro-4-dc2ba58835b4f9a781177b51ea5470a5.png";